import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://uounannjrkccmepgxaln.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVvdW5hbm5qcmtjY21lcGd4YWxuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjQxNzc5NTMsImV4cCI6MjA3OTc1Mzk1M30.hE6QAlI5ewd80R87XGh8EqTeCAXGnYx3jhWzn2TwY48'

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Import the supabase client like this:
// For React:
// import { supabase } from "@/integrations/supabase/client";
// For React Native:
// import { supabase } from "@/src/integrations/supabase/client";
